// Forked from ../../ResultsDropdown/GroupTags/GroupTags.tsx and ../../ResultsDropdown/GroupTags/Tag.tsx
// (the chip click) — keep in sync until phase_0 cleanup.
import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import type { TagsSearchResults } from '../../types';
import { onTagSearch } from '../../helpers/searchUtils';
import { NavigableChip } from '../SharedComponents';
import { useSearch, useSearchMode } from '../../SpotlightState';

type Props = {
	tags: TagsSearchResults;
};

export function GroupTags({ tags }: Props) {
	const { clearResults } = useSearch();
	const { isHybridSearchOn } = useSearchMode();
	const { translate } = useTranslate();

	return (
		<StyledRow>
			<StyledLabel>{translate('spotlight.dropdown.tags')}</StyledLabel>
			<StyledChipRow>
				{tags.map((tagName, index) => {
					if (index % 2 !== 0) {
						return null;
					}

					const tagQty = tags[index + 1];

					return (
						<NavigableChip
							key={tagName}
							onSelect={() =>
								onTagSearch({
									isHybridSearchOn,
									tagName,
									resetSearch: clearResults,
								})
							}
						>
							{tagName} {tagQty}
						</NavigableChip>
					);
				})}
			</StyledChipRow>
		</StyledRow>
	);
}

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	gap: ${token.spacing4};
	padding: 0 ${token.spacing5};
`;

const StyledLabel = styled.div`
	width: auto;
	font-weight: 500;
	color: ${token.colorTextMuted};
`;

const StyledChipRow = styled.div`
	display: flex;
	flex: 1;
	min-width: 0;
	gap: ${token.spacing4};
	overflow-x: auto;
`;
